import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  isLoggedIn: false,
  user: null,
  startTime: null,
  startTimeUserId: null, // Store the userId associated with startTime
  isVerificationPending:false
};

export const authSlice = createSlice({
  name: "auth",
  initialState: initialState,
  reducers: {
    login: (state, action) => {
      state.isLoggedIn = true;
      state.user = { ...action.payload, onboardingCompleted: false };
    },   
    logout: (state) => {
      // Object.assign(state, initialState);
      // return initialState
      return { ...initialState };
    },
    setOnboardingCompleted: (state) => {
      if (state.user) {
        state.user.onboardingCompleted = true;
      }
    },
    resetStartTime: (state) => {
      state.startTime = null;
      state.startTimeUserId = null; // Reset the user_id for the startTime
    },
    updateStartTime: (state, action) => {
      const currentTime = new Date().getTime();
      state.startTime = currentTime;
      state.startTimeUserId = action.payload.userId; // Store the user_id with the startTime
    },
    onVerificationPending:(state)=>{
      state.isVerificationPending = true;
    }
  },
});

export const { login, logout, setOnboardingCompleted, resetStartTime, updateStartTime,onVerificationPending } = authSlice.actions;

export default authSlice.reducer;
